import { MedicalNoteActivity, MedicalNoteType } from '@uplift/api';
import { DischargeNoteReviewSection, DischargeNoteReviewSubSection } from './ReviewSections.component';
import { Box, Typography } from '@mui/material';
import { useAllDiagnosisQuery } from '@uplift/queries';

export type DischargeSummaryReviewSectionProps = {
  note: MedicalNoteActivity<MedicalNoteType.therapyDischargeNote | MedicalNoteType.psychiatryDischargeNote>;
};

export const DischargeSummaryReviewSection: React.VFC<DischargeSummaryReviewSectionProps> = ({ note }) => {
  const { data: diagnoses = [] } = useAllDiagnosisQuery();
  const { form, diagnosisIds = [] } = note;

  const dischargeDiagnosis = diagnoses.filter(d => diagnosisIds.includes(d.id));

  const continuingCareRecommendations = form['continuingCareRecommendations'].value.split(', ');

  return (
    <DischargeNoteReviewSection title="Discharge Summary">
      <DischargeNoteReviewSubSection title="Reason for Discharge">
        <Typography>{form['reasonForDischarge'].value}</Typography>
      </DischargeNoteReviewSubSection>
      <DischargeNoteReviewSubSection title="Discharge Diagnosis" isEmpty={!dischargeDiagnosis.length} emptyMessage="Not Filled">
        <Box display="flex" flexDirection="column">
          {dischargeDiagnosis.map((d) => (
            <Typography key={d.id}>{d.code} {d.name}</Typography>
          ))}
        </Box>
      </DischargeNoteReviewSubSection>
      <DischargeNoteReviewSubSection title="Prognosis">
        <Typography>{form['prognosis'].value}</Typography>
      </DischargeNoteReviewSubSection>
      <DischargeNoteReviewSubSection title="Continuing Care Recommendations">
        <Box display="flex" flexDirection="column" gap="8px">
          {continuingCareRecommendations.map((r, idx) => (
            <Typography key={idx}>{r}</Typography>
          ))}
        </Box>
      </DischargeNoteReviewSubSection>
      <DischargeNoteReviewSubSection title="Discharge Summary">
        <Typography>{form['dischargeSummary'].value}</Typography>
      </DischargeNoteReviewSubSection>
    </DischargeNoteReviewSection>
  );
};
